import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Layout from "scenes/layout";
import Dashboard from "scenes/dashboard";
import Excellent_It_Services from "scenes/Excellent_It_Services";
import Customers from "scenes/customers";

import Geography from "scenes/geography";
import Overview from "scenes/overview";
import Daily from "scenes/daily";
import Monthly from "scenes/monthly";
import Breakdown from "scenes/breakdown";
import Slider from "scenes/slider";
import Admin from "scenes/admin";
import Performance from "scenes/performance";
import BestSolution from "scenes/best solution";
import Offer from "scenes/offering";
import WorkProcess from "scenes/work process";
import Blog from "scenes/blogNews";
import TalkToUs from "scenes/talktous";
import OurTeams from "scenes/ourTeams";
import Login from "scenes/login";
import Register from "scenes/register";
import Pricing from "scenes/pricing";
import SkillsCategory from "scenes/skillsCategory";
import Projects from "scenes/projects";

import ClonePage from "scenes/clonepage";
import CreatePageStepper from "scenes/createpage";

import CaseStudies from "scenes/caseStudies";
import CreateCaseStudy from "scenes/caseStudies/CreateCaseStudy";

// import Cookies from 'js-cookie';
import axios from "axios";
import { useDispatch } from "react-redux";
import { setLogin } from "state";
// import ProtectedRoute from "./components/ProtectedRoute";
import FullPageLoader from "components/loader"; // adjust path as needed

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.global.token);
  const isAuth = Boolean(token);
  console.log("isAuth", isAuth);

  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const checkAuth = async () => {
      try {
        console.log("in the check auth");

        const response = await axios.get(`${apiUrl}/api/auth/checkAuth`, {
          withCredentials: true,
        });
        console.log("Auth check response:", response.data);

        if (response.data.isAuthenticated) {
          dispatch(
            setLogin({
              user: response.data.user,
              token: response.data.token,
            }),
          );
        }
      } catch (error) {
        console.error("Auth check failed:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!isAuth) {
      console.log("not isAuth");

      checkAuth();
    }
  }, [isAuth, dispatch, apiUrl]);

  if (loading) return <FullPageLoader />;

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            {/* Public routes */}
            <Route
              path="/login"
              element={
                !isAuth ? <Login /> : <Navigate to="/dashboard" replace />
              }
            />
            <Route
              path="/register"
              element={
                !isAuth ? <Register /> : <Navigate to="/dashboard" replace />
              }
            />

            {/* Protected routes */}
            <Route
              element={isAuth ? <Layout /> : <Navigate to="/login" replace />}
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route
                path="/Excellent It Services"
                element={<Excellent_It_Services />}
              />
              <Route path="/progress" element={<Customers />} />
              <Route path="/slider" element={<Slider />} />
              <Route path="/About Us" element={<Geography />} />
              <Route path="/best-solution" element={<BestSolution />} />
              <Route path="/Our-Offering" element={<Offer />} />
              <Route path="/work-process" element={<WorkProcess />} />
              <Route path="/blog-and-news" element={<Blog />} />
              <Route path="/talk-to-us" element={<TalkToUs />} />
              <Route path="/our-teams" element={<OurTeams />} />

              {/* Pages / Clone — added by tayyab */}
              <Route path="/pages" element={<ClonePage />} />

              {/*Case Study routes  */}

              <Route path="/case-studies" element={<CaseStudies />} />
              <Route
                path="/case-studies/create"
                element={<CreateCaseStudy />}
              />
              <Route
                path="/case-studies/edit/:caseId"
                element={<CreateCaseStudy />}
              />

              <Route path="/overview" element={<Overview />} />
              <Route path="/daily" element={<Daily />} />
              <Route path="/monthly" element={<Monthly />} />
              <Route path="/breakdown" element={<Breakdown />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/skillsCategory" element={<SkillsCategory />} />
              <Route path="/projects" element={<Projects />} />
            </Route>
            {/* Page Builder — no layout, no navbar */}
            <Route path="/pages/create" element={<CreatePageStepper />} />
            <Route path="/pages/edit/:pageId" element={<CreatePageStepper />} />

            {/* Catch-all route */}
            <Route
              path="*"
              element={
                <Navigate to={isAuth ? "/dashboard" : "/login"} replace />
              }
            />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
